module.exports = __webpack_public_path__ + "img/b17ace0.png";